
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/[business]/access/[category]/[article]",
      function () {
        return require("private-next-pages/[lang]/[business]/access/[category]/[article].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/[business]/access/[category]/[article]"])
      });
    }
  